/**
 * Extract a user-facing message from an Axios / fetch error response.
 * Aligns with backend {@code ApiResponseDTO.message} and legacy {@code ErrorResponse.messages}.
 */
export function getApiErrorMessage(error, fallback = 'Something went wrong. Please try again.') {
  if (!error) return fallback;

  const data = error.response?.data;
  if (data && typeof data === 'object') {
    if (typeof data.message === 'string' && data.message.trim()) {
      return data.message.trim();
    }
    if (typeof data.messages === 'string' && data.messages.trim()) {
      return data.messages.trim();
    }
    if (typeof data.detail === 'string' && data.detail.trim()) {
      return data.detail.trim();
    }
  }

  if (typeof error.message === 'string' && error.message.trim()) {
    return error.message.trim();
  }

  return fallback;
}
